import React, { useEffect } from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Layout from "../../../layout/layout";
import styles from "./ratingProduct.module.scss";
import img1 from "../../../assets/images/features-15.png";
import Image from "next/image";
import { useSelector } from "react-redux";
import { selectProduct } from "@/store/slices/product";
import httpClient from "@/api/http-client";
import endpoints from "@/api/endpoints";
import { Swiper, SwiperSlide } from "swiper/react";

const RatingProduct = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [show, setShow] = useState(false);
  const [reviewSummarys, setReviewSummarys] = useState<any>(null);
  const [reviewLists, setReviewLists] = useState<any>(null);
  const [selectedComment, setSelectedComment] = useState<any>(null);
  const [zoomedImg, setzoomedImg] = useState<any>(0);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const productState = useSelector(selectProduct);
  const reviewSummary = async () => {
    const { data } = await httpClient.get(
      endpoints.feedback.feedbackSummary(productState.data?.slug)
    );
    setReviewSummarys(data);
  };
  const reviewList = async (page: number) => {
    const { data } = await httpClient.get(
      endpoints.feedback.feedbackSummaryList(productState.data?.slug),
      {
        params: {
          page: page,
        },
      }
    );
    setReviewLists(data);
  };

  const selectedCommentData = async (id: number, ind: number) => {
    const { data } = await httpClient.get(
      endpoints.feedback.reviewByCustomer(productState.data?.slug, id)
    );
    setSelectedComment(data);
    setzoomedImg(ind);
    handleShow();
  };
  useEffect(() => {
    reviewSummary();
    reviewList(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productState.data]);

  useEffect(() => {
    console.log(reviewSummarys);
  }, [reviewSummarys]);
  return (
    <>
      {" "}
      <div className={styles.ratingproduct_main}>
        <div className="container">
          {reviewSummarys && (
            <div className={styles.ratingproduct_main_line}>
              <div className="row">
                <div className="col-md-12">
                  <div className={styles.heading}>
                    Happy Customer Ratings & Reviews
                  </div>
                </div>
                <div className="col-md-3">
                  {reviewSummarys?.averageRating && (
                    <div className={styles.rating_contant}>
                      <div>
                        <button
                          className={
                            Number(reviewSummarys?.averageRating) >= 1
                              ? styles.active
                              : ""
                          }
                        >
                          <i className="bi bi-star-fill"></i>
                        </button>
                        <button
                          className={
                            Number(reviewSummarys?.averageRating) >= 2
                              ? styles.active
                              : ""
                          }
                        >
                          <i className="bi bi-star-fill"></i>
                        </button>
                        <button
                          className={
                            Number(reviewSummarys?.averageRating) >= 3
                              ? styles.active
                              : ""
                          }
                        >
                          <i className="bi bi-star-fill"></i>
                        </button>
                        <button
                          className={
                            Number(reviewSummarys?.averageRating) >= 4
                              ? styles.active
                              : ""
                          }
                        >
                          <i className="bi bi-star-fill"></i>
                        </button>
                        <button
                          className={
                            Number(reviewSummarys?.averageRating) == 5
                              ? styles.active
                              : ""
                          }
                        >
                          <i className="bi bi-star-fill"></i>
                        </button>
                      </div>
                      {/* <div className={styles.text}>
                        {reviewSummarys?.averageRating}/5
                      </div> */}
                    </div>
                  )}
                  {/* {reviewSummarys?.totalRatings && (
                    <p className={styles.based_text}>
                      Based on {productState.data?.totalRatings} Ratings &
                      Reviews
                    </p>
                  )} */}
                </div>
                {/* {!!Object.keys(reviewSummarys?.options).length && (
                  <div className="col-md-4">
                    <div className={styles.rating_tag}>
                      <div className={styles.rating_heading}>
                        <i className="bi bi-hand-thumbs-up-fill"></i> What
                        Customers Liked
                      </div>
                      <div className={styles.rating_tag_button}>
                        {Object.keys(reviewSummarys?.options).length &&
                          Object.keys(reviewSummarys?.options).map((v) => (
                            <>
                              {" "}
                              <button>
                                {v} ({reviewSummarys?.options?.[v]})
                              </button>
                            </>
                          ))}
                      </div>
                    </div>
                  </div>
                )} */}
                {!!reviewSummarys?.images?.length && (
                  <div className="col-md-9">
                    <div className={styles.image_tag}>
                      <div className={styles.image_heading}>
                        Images by Customers
                        {/* ({reviewSummarys.images?.length}) */}
                      </div>
                      <div className="row g-3">
                        <div className="slider-gift-main">
                          <Swiper
                            slidesPerView={5}
                            watchSlidesProgress={true}
                            navigation={{
                              nextEl: ".arrow-right",
                              prevEl: ".arrow-left",
                            }}
                            autoHeight={true}
                            pagination={false}
                            // pagination={{
                            //   clickable: true,
                            //   dynamicBullets: true,
                            // }}
                          >
                            {reviewSummarys &&
                              !!reviewSummarys.images?.length &&
                              reviewSummarys.images.map(
                                (x: any, index: any) => (
                                  <>
                                    {" "}
                                    {x.images.map((v: any, k: any) => (
                                      <SwiperSlide key={index + k}>
                                        <div
                                          className={styles.rating_slide_img}
                                          onClick={() => {
                                            selectedCommentData(x.id, k);
                                          }}
                                        >
                                          <Image
                                            src={v}
                                            alt="Rating image"
                                            height={150}
                                            width={140}
                                          />
                                        </div>{" "}
                                      </SwiperSlide>
                                    ))}
                                  </>
                                )
                              )}{" "}
                          </Swiper>
                          {reviewSummarys.images?.length > 3 && (
                            <>
                              {" "}
                              <button
                                type="button"
                                className={`${
                                  styles.arrow_next
                                } ${"arrow-left"}`}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="#999"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                                </svg>
                              </button>
                              <button
                                type="button"
                                className={`${
                                  styles.arrow_prv
                                } ${"arrow-right"}`}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="#999"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg>
                              </button>
                            </>
                          )}
                        </div>

                        {/* {reviewSummarys &&
                      reviewSummarys.images?.length &&
                      reviewSummarys.images.map((v: any) => (
                        <>
                          <div className="col-md-4">
                            <a
                              className={styles.image_container}
                              onClick={handleShow}
                            >
                              <Image
                                src={v}
                                alt="Rating image"
                                height={150}
                                width={140}
                              />
                            </a>
                          </div>
                        </>
                      ))} */}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {!!reviewLists?.data?.length &&
            reviewLists?.data.map((v: any) => (
              <>
                {" "}
                <div className={styles.ratingproduct_user}>
                  {/* <div className={styles.customer_review_head}>
              Customer Reviews : Showing 1 - 4 out of 1111
            </div> */}
                  <div className={styles.customer_review_icon}>
                    <div className={styles.user_icon}>
                      <i className="bi bi-person-circle"></i>
                    </div>
                    <div>
                      <p>{v.user_name}</p>
                      <p>
                        <small>{v.created_at}</small>
                      </p>
                    </div>
                  </div>
                  {v?.rating && (
                    <div className={styles.rating_contant}>
                      <div>
                        <button
                          className={
                            Number(v?.rating) >= 1 ? styles.active : ""
                          }
                        >
                          <i className="bi bi-star-fill"></i>
                        </button>
                        <button
                          className={
                            Number(v?.rating) >= 2 ? styles.active : ""
                          }
                        >
                          <i className="bi bi-star-fill"></i>
                        </button>
                        <button
                          className={
                            Number(v?.rating) >= 3 ? styles.active : ""
                          }
                        >
                          <i className="bi bi-star-fill"></i>
                        </button>
                        <button
                          className={
                            Number(v?.rating) >= 4 ? styles.active : ""
                          }
                        >
                          <i className="bi bi-star-fill"></i>
                        </button>
                        <button
                          className={
                            Number(v?.rating) == 5 ? styles.active : ""
                          }
                        >
                          <i className="bi bi-star-fill"></i>
                        </button>
                      </div>
                      {/* <div className={styles.text}>{v?.rating}/5</div> */}
                    </div>
                  )}
                  {/* <p className={styles.text_green}>
            <i className="bi bi-hand-thumbs-up-fill"></i> POSITIVES
          </p> */}
                  {/* <div className={styles.rating_tag}>
            <div className={styles.rating_tag_button}>
              <button>Design (917)</button>
              <button>Size/fit (495)</button>
              <button>Quality (688)</button>
              <button>Delivery (352)</button>
              <button>Packaging (460)</button>
              <button>Customer service (738)</button>
            </div>
          </div> */}
                  <p className="mt-3 mb-3">
                    {v?.comment}
                    {/* <a>Read more</a> */}
                  </p>
                  <div className={styles.user_image_container}>
                    {v &&
                      !!v.images?.length &&
                      v.images.map((img: any) => (
                        <>
                          <div className={styles.user_image_upload}>
                            <a className={styles.image_container}>
                              <Image
                                src={img}
                                alt="Rating image"
                                height={150}
                                width={140}
                              />
                            </a>
                          </div>
                        </>
                      ))}
                  </div>
                </div>
              </>
            ))}
          {!!reviewLists?.data?.length && (
            <>
              <button
                className={styles.next_button}
                disabled={
                  Number(reviewLists?.totalPages) === Number(reviewLists?.page)
                }
                onClick={() => {
                  reviewList(Number(reviewLists?.page) + 1);
                }}
              >
                <i className="bi bi-chevron-right"></i>
              </button>
              <button
                className={styles.prv_button}
                onClick={() => {
                  reviewList(Number(reviewLists?.page) - 1);
                }}
                disabled={reviewLists?.page == 1}
              >
                <i className="bi bi-chevron-left"></i>
              </button>
            </>
          )}
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        size="lg"
        className={styles.custom_modal_user}
      >
        <Modal.Header closeButton className={styles.header}>
          {/* <Modal.Title>Modal heading</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6">
              <div className={styles.pop_image}>
                <Image
                  src={selectedComment?.images[zoomedImg]}
                  alt="Rating image"
                  height={492}
                  width={371}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className={styles.ratingproduct_user}>
                {/* <div className={styles.customer_review_head}>
              Customer Reviews : Showing 1 - 4 out of 1111
            </div> */}
                <div className={styles.customer_review_icon}>
                  <div className={styles.user_icon}>
                    <i className="bi bi-person-circle"></i>
                  </div>
                  <div>
                    <p>{selectedComment?.user_name}</p>
                    <p>
                      <small>{selectedComment?.created_at}</small>
                    </p>
                  </div>
                </div>
                {selectedComment?.rating && (
                  <div className={styles.rating_contant}>
                    <div>
                      <button
                        className={
                          Number(selectedComment?.rating) >= 1
                            ? styles.active
                            : ""
                        }
                      >
                        <i className="bi bi-star-fill"></i>
                      </button>
                      <button
                        className={
                          Number(selectedComment?.rating) >= 2
                            ? styles.active
                            : ""
                        }
                      >
                        <i className="bi bi-star-fill"></i>
                      </button>
                      <button
                        className={
                          Number(selectedComment?.rating) >= 3
                            ? styles.active
                            : ""
                        }
                      >
                        <i className="bi bi-star-fill"></i>
                      </button>
                      <button
                        className={
                          Number(selectedComment?.rating) >= 4
                            ? styles.active
                            : ""
                        }
                      >
                        <i className="bi bi-star-fill"></i>
                      </button>
                      <button
                        className={
                          Number(selectedComment?.rating) == 5
                            ? styles.active
                            : ""
                        }
                      >
                        <i className="bi bi-star-fill"></i>
                      </button>
                    </div>
                    <div className={styles.text}>
                      {selectedComment?.rating}/5
                    </div>
                  </div>
                )}
                {/* <p className={styles.text_green}>
                  <i className="bi bi-hand-thumbs-up-fill"></i> POSITIVES
                </p>
                <div className={styles.rating_tag}>
                  <div className={styles.rating_tag_button}>
                    <button>Design (917)</button>
                    <button>Size/fit (495)</button>
                    <button>Quality (688)</button>
                    <button>Delivery (352)</button>
                    <button>Packaging (460)</button>
                    <button>Customer service (738)</button>
                  </div>
                </div> */}
                <p className="mt-3 mb-3">
                  {selectedComment?.comment}
                  {/* <a>Read more</a> */}
                </p>
                <div className={styles.user_image_container}>
                  {selectedComment &&
                    selectedComment?.images?.length > 1 &&
                    selectedComment?.images.map((img: any, index: any) => (
                      <>
                        <div
                          className={styles.user_image_upload}
                          onClick={() => setzoomedImg(index)}
                        >
                          <Image
                            src={img}
                            alt="Rating image"
                            height={150}
                            width={140}
                          />
                        </div>
                      </>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RatingProduct;
